import { useEffect, useState } from "react"
import { getTalleById, postTalle, patchTalle } from "../../services/TallesServices"
import { TallesFormContext } from "./TallesContext"
import { useNavigate, useParams } from 'react-router-dom';
//import { Color } from '../../routes/RoutesConstants'

export const TallesFormState = ({ children }) => {
    const [report, setReport] = useState({})
    const navigate = useNavigate();
    const { id } = useParams()

    useEffect(() => {
        if (id) getTalleByIdData(id)
    }, [])

    const getTalleByIdData = async (id) => {
        let res = await getTalleById(id)
        if (res) setReport(res)
    }

    const postTalleData = async (body) => {
        const res = await postTalle(body)
        if (res) navigate("/talles");
    }

    const patchTalleData = async (id, body) => {
        const res = await patchTalle(id, body)

        if (res) navigate("/talles");
    }


    return <TallesFormContext.Provider value={{
        report,
        postTalleData,
        patchTalleData,
    }} >
        {children}
    </TallesFormContext.Provider>
}